import { useSyncExternalStore } from 'react'

let impersonatedUserId: string | undefined
const listeners = new Set<() => void>()

export const getImpersonatedUserId = (): string | undefined => impersonatedUserId

export const setImpersonatedUserId = (next: string | undefined): void => {
  impersonatedUserId = next
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useImpersonatedUserId = (): [string | undefined, (next: string | undefined) => void] => [
  useSyncExternalStore(subscribe, getImpersonatedUserId),
  setImpersonatedUserId,
]
